import React, {useState, useEffect, useRef} from "react";
import { ChevronDown } from "lucide-react";

export const CustomSelect = React.memo(({ value, options, onChange, minWidth = '110px' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selectedLabel = options.find(opt => opt.value === value)?.label || value;

    return (
        <div style={{ position: 'relative' }} ref={dropdownRef}>
            <div 
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    padding: '6px 14px', borderRadius: '8px',
                    border: '1px solid #e2e8f0', fontSize: '12px', fontWeight: '600',
                    color: '#334155', background: '#fff',
                    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    minWidth: minWidth, transition: 'all 0.2s ease', gap: '8px'
                }}
                onMouseOver={(e) => { e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)'; }}
                onMouseOut={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)'; }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {selectedLabel}
                </div>
                <ChevronDown size={14} color="#64748b" />
            </div>

            {isOpen && (
                <div style={{
                    position: 'absolute', top: 'calc(100% + 4px)', left: 0, 
                    background: '#fff', borderRadius: '8px',
                    border: '1px solid #e2e8f0', boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    width: '100%', minWidth: minWidth, zIndex: 100, overflow: 'hidden'
                }}>
                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        {options.map((opt, index) => (
                            <div 
                                key={index}
                                onClick={() => {
                                    onChange(opt.value);
                                    setIsOpen(false);
                                }}
                                style={{
                                    padding: '8px 14px', fontSize: '12px', color: '#475569', fontWeight: '500',
                                    cursor: 'pointer', display: 'flex', alignItems: 'center',
                                    background: value === opt.value ? '#f8fafc' : 'transparent',
                                    transition: 'background 0.2s'
                                }}
                                onMouseOver={(e) => e.currentTarget.style.background = '#f8fafc'}
                                onMouseOut={(e) => e.currentTarget.style.background = value === opt.value ? '#f8fafc' : 'transparent'}
                            >
                                <span style={{ color: value === opt.value ? '#0f172a' : 'inherit', fontWeight: value === opt.value ? '600' : '500' }}>{opt.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
});